<template>
  <div class="container" :class="{ focus: phoneFocus }">
    <div class="swiper-box">
      <swiper class="swiper-wrapper" :options="swiperOptions">
        <template v-if="settings.sbcBanner && settings.sbcBanner.length">
          <swiper-slide
            class="swiper-slide"
            v-for="item in settings.sbcBanner"
            :key="item"
          >
            <van-image fit="cover" :src="item" />
          </swiper-slide>
        </template>
        <swiper-slide class="swiper-slide" v-else>
          <van-image fit="cover" src="">
            <template v-slot:error>暂无轮播图</template>
          </van-image>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="phone-box">
      <van-cell-group class="phone-ipt" inset v-if="!settings.onlySelfExchange">
        <van-field
          v-model.trim="phoneValue"
          :maxlength="11"
          clearable
          type="tel"
          placeholder="请输入手机号码"
          @focus="phoneFocus = true"
          @blur="phoneFocus = false"
        >
          <template #right-icon>
            <div class="phone-ipt-icon">
              <van-popover
                v-model="showPhonePopover"
                trigger="click"
                :actions="phoneHistory"
                @select="onSelectPhone"
              >
                <template #reference>
                  <div style="display: flex; align-items: center;">
                    <span>历史号码</span>
                    <van-icon name="arrow" />
                  </div>
                </template>
              </van-popover>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <div class="phone-btns">
        <van-button
          round
          class="firstBut"
          v-if="!settings.onlySelfExchange"
          :disabled="
            phoneValue.length !== 11 || phoneValue.substring(0, 1) !== '1'
          "
          color="linear-gradient(to right, #0173FF, #5FD2FF)"
          @click="sbcChargeCharge(phoneValue)"
          >兑 换</van-button
        >

        <van-button
          round
          color="linear-gradient(to right, #0173FF, #5FD2FF)"
          @click="sbcChargeCharge(settings.phone || userData.phone)"
        >
          {{settings.phone || userData.phone ? '给自己兑换' : '去绑定手机号'}}
        </van-button>
      </div>
    </div>

    <div class="point-exchange-box">
      <div class="exchange-head">
        <div class="exchange-head-title">立即积分/票兑换</div>
        <div class="exchange-head-msg">
          我的票：{{ userData.pointCredit || "-" }}票
        </div>
      </div>
      <div class="exchange-main">
        <div
          class="exchange-main-item"
          :class="{ active: activeProductId === item.productId }"
          v-for="item in productList"
          :key="item.productId"
          @click="activeProductId = item.productId"
        >
          <div class="exchange-main-item-top">
            <div class="item-top-price">{{ item.faceValueCent / 100 }}积分</div>
            <!-- <div class="item-top-name">超商卡</div> -->
          </div>
          <div class="exchange-main-item-bottom">{{ item.pricePoint }}票</div>

          <div class="item-other-icon" v-if="item.productId === 0">其它</div>
        </div>

        <!-- <div class="exchange-main-item other" @click="clickOtherAmount">
          <div class="exchange-main-item-top">其它<br />数量</div>
          <div
            class="other-cancel"
            v-if="activeProduct.productId === 0"
            @click.stop="clickCancelOther"
          >
            取消
          </div>
        </div> -->
      </div>
      <!-- <div class="tips" v-show="activeProduct.pricePoint > userData.pointCredit">很抱歉，您的票数不够，不能兑换！</div> -->
    </div>

    <div class="shop-box" :class="{ focus: phoneFocus }">
      <div class="shop-box-head">
        <div class="shop-box-head-title">支持超级商家品牌</div>
        <div
          class="shop-box-head-btn"
          @click="toUrl('/pages/superBusinessCard/UsageGuidelines')"
        >
          查看如何使用
        </div>
      </div>
      <div class="shop-box-icons">
        <template v-if="settings.sbcIcon && settings.sbcIcon.length">
          <van-image
            class="shop-box-icon"
            fit="cover"
            :src="item"
            round
            v-for="item in settings.sbcIcon"
            :key="item"
          />
        </template>
        <div class="shop-box-noicon" v-else>暂无超级商家品牌</div>
      </div>
    </div>

    <!-- 点击其他数量 -->
    <van-popup v-model="otherAmountShow">
      <div class="dialog-box">
        <div class="dialog-head">
          超商卡金额
          <div class="dialog-head-close" @click="otherAmountShow = false">
            ×
          </div>
        </div>

        <van-cell-group style="margin: 3vw 5vw 8vw;" inset>
          <van-field
            v-model.trim="otherPrice"
            type="digit"
            clearable
            placeholder="请输入超商卡金额"
          />
        </van-cell-group>

        <div class="conform-btns">
          <van-button type="default" block @click="otherAmountShow = false">
            取消
          </van-button>
          <van-button
            color="linear-gradient(to right, #FF0129, #FF7F5F)"
            @click="confirmOtherAmount"
            block
          >
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 确认兑换弹框 -->
    <van-popup
      v-model="confirmShow"
      :close-on-click-overlay="false"
      style="border-radius: 10px"
    >
      <div class="dialog-box">
        <div class="dialog-head">
          确认兑换
          <div class="dialog-head-close" @click="confirmShow = false">×</div>
        </div>

        <div class="dialog-con">
          <div class="con-item">手机号码：{{ confirmPhone }}</div>
          <div class="con-item">
            超商金额：{{ activeProduct.faceValueCent / 100 }}积分
          </div>
          <div class="con-item">消费积分：{{ activeProduct.pricePoint }}分</div>
        </div>

        <div class="conform-btns">
          <van-button type="default" block @click="confirmShow = false">
            取消
          </van-button>
          <van-button
            color="linear-gradient(to right, #FF0129, #FF7F5F)"
            @click="confirmCharge"
            block
          >
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 兑换中弹框 -->
    <van-popup
      v-model="loadingShow"
      :close-on-click-overlay="false"
      style="border-radius: 10px"
    >
      <div class="dialog-box">
        <div class="dialog-head">
          兑换中
          <div class="dialog-head-close" @click="loadingShow = false">×</div>
        </div>

        <div class="dialog-con">
          <div class="loading-con">
            <van-loading type="spinner" size="23vw" color="#1989fa" />
            <span class="loading-con-text"
              >{{
                activeProduct.faceValueCent / 100
              }}元超商卡<br />兑换下单中</span
            >
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 兑换成功弹框 -->
    <van-popup
      v-model="succShow"
      :close-on-click-overlay="false"
      style="border-radius: 10px"
    >
      <div class="dialog-box">
        <div class="dialog-head">
          兑换成功
          <div class="dialog-head-close" @click="succShow = false">×</div>
        </div>

        <div class="dialog-con">
          <div class="loading-con">
            <van-icon name="checked" size="23vw" color="#1989fa" />
            <span class="loading-con-text"
              >成功兑换{{ activeProduct.faceValueCent / 100 }}元超商卡
              <br />赶快去使用吧~</span
            >
          </div>
        </div>

        <div class="conform-btns">
          <van-button
            type="default"
            block
            @click="toUrl('/pages/superBusinessCard/UsageGuidelines')"
          >
            使用指南
          </van-button>

          <van-button
            class="open-miniapp-btn"
            color="linear-gradient(to right, #FF0129, #FF7F5F)"
            block
          >
            <div class="launch-btn"></div>
            去使用
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import api from "../../api";
import store from "../../api/store";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "../../../static/swiper.min.css";
export default {
  title: "超商联盟兑换",
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
        },
        effect: "coverflow",
        slidesPerView: 1.35,
        centeredSlides: true,
      },

      userData: {
        phone: "",
        pointCredit: 0,
      },
      settings: {
        enabled: false,
        pointsPerCent: 0,
        sbcBanner: null,
        sbcIcon: null,
      },

      phoneFocus: false,
      phoneValue: "",
      confirmPhone: "",
      showPhonePopover: false,
      phoneHistory: [],

      productList: [],
      activeProductId: -1,
      otherPrice: "",
      otherAmountShow: false,

      confirmShow: false,
      loadingShow: false,
      succShow: false,

      openMiniappSucc: false,
    };
  },
  created() {
    if (store.loginedUser) {
      this.userData = store.loginedUser;
    } else {
      this.getUserPoint();
    }

    this.getSettings();
    this.getProductList();
    this.sbcChargePhoneHistory();
  },
  computed: {
    activeProduct() {
      return (
        this.productList.find(
          item => item.productId === this.activeProductId
        ) || {
          faceValueCent: "",
          pricePoint: "",
          productId: "",
        }
      );
    },
  },
  methods: {
    openMiniapp() {
      const box = document.body.querySelector(".launch-btn");
      this.wx_launch({
        ele: this.$el,
        // appid: "wx2b4c74af074f2085",
        appid: this.settings.miniProgramId,
        content: `<div class="test-btn"></div>
      <style>
      .test-btn{
          width: ${box.clientWidth}px;
          height: ${box.clientHeight}px;
        }
      </style>`,
      });
      this.openMiniappSucc = true;
    },
    is_weixn() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    is_version() {
      const wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
      // 微信正常版本号 wxInfo[1] = "8.0.1840" (示例)
      // 微信异常版本号 wxInfo[1] = "8.0.1.1840" (示例)
      //进行split转成数组进行判断 ['8','0','1','1840'] (示例)
      const version = wxInfo[1].split(".");
      // console.log('version', version);
      // 判断版本在7.0.12及以上的版本
      if (Number(version[0]) > 7) {
        return true;
      } else if (Number(version[0]) === 7) {
        if (Number(version[1]) > 0) {
          return true;
        } else if (Number(version[1]) === 0) {
          if (Number(version[2]) >= 12) return true;
        }
      }
      return false;
    },
    /* 
    {
        ele:"", // 元素ID
        appid:"", // 小程序id号 wx_****
        username: "", // gh_**** 
        url:"", // 跳转小程序的页面路径地址 例: pages/home/home.html - (后面必须带上.html后缀 否则IOS跳转时出现小程序页面未配置)
        content:"" // html字符串 例: "<button>点我</button>"
    }
  */
    wx_launch(info) {
      if (!this.is_weixn()) return;
      if (this.is_version) {
        const btn = info.ele.querySelector(".launch-btn"); //获取元素
        const script = document.createElement("script"); // 创建script内容插槽 避免template标签冲突
        script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
        script.text = info.content; // 自定义的html字符串内容
        const html = `<wx-open-launch-weapp
                      style="display: block;width: 100%;height: 100%" 
                      appid="${info.appid}">${script.outerHTML}</wx-open-launch-weapp>`;
        btn.innerHTML = html; // html字符串赋值
      } else {
        alert("您的版本号不支持");
      }
    },

    toUrl(url) {
      this.$routerPush(this, url);
    },
    getUserPoint() {
      api.user.getPersonalInfo(user => {
        this.userData = user;
      });
    },
    getSettings() {
      api.superBusinessCard.sbcChargeSetting(data => {
        console.log(data, "超商卡设置***");
        this.settings = data;
      });
    },
    getProductList() {
      api.superBusinessCard.sbcChargeProductList(data => {
        console.log(data, "瑞祥商品列表***");
        this.productList = data.list;
        if (data.list.length > 0) {
          this.activeProductId = data.list[0].productId;
        }
      });
    },
    sbcChargePhoneHistory() {
      api.superBusinessCard.sbcChargePhoneHistory(
        {
          limit: 10,
        },
        data => {
          console.log(data, "瑞祥充值手机历史***");
          if (data.records.length) {
            data.records.forEach(item => {
              item.text = item.phone;
            });
            this.phoneHistory = data.records;
            this.phoneValue = data.records[0].phone;
          } else {
            this.phoneHistory = [
              {
                text: "暂无历史记录",
                phone: "",
              },
            ];
          }
        }
      );
    },
    onSelectPhone(val) {
      console.log(val, "onSelectPhone");
      if (val.phone) this.phoneValue = val.phone;
    },
    clickOtherAmount() {
      if (this.settings.globalProfit) {
        this.otherAmountShow = true;
      } else {
        this.$toast("获取超商卡设置出错");
      }
    },
    clickCancelOther() {
      let fi = this.productList.findIndex(item => item.productId === 0);
      if (fi !== -1) {
        this.productList.splice(fi, 1);
        this.activeProductId = -1;
      }
    },
    confirmOtherAmount() {
      if (!(Number(this.otherPrice) > 0)) {
        this.$toast("请输入正确的金额");
        return;
      }
      if (
        this.productList.find(
          item => item.faceValueCent === this.otherPrice * 100
        )
      ) {
        this.$toast("已存在相同挡位金额");
        return;
      }
      let fi = this.productList.findIndex(item => item.productId === 0);
      let p = {
        productId: 0,
        faceValueCent: this.otherPrice * 100,
        pricePoint: Math.ceil(
          this.otherPrice *
            100 *
            this.settings.globalProfit *
            this.settings.pointsPerCent
        ),
      };
      if (fi !== -1) {
        this.productList.splice(fi, 1, p);
      } else {
        this.productList.push(p);
      }
      this.activeProductId = 0;
      this.otherAmountShow = false;
    },
    sbcChargeCharge(phone) {
      if(!phone) {
        let apiHost = process.env.apiHost;
        location.href = apiHost.includes("test") ? `http://fx2.test.gzhaoku.com/common/skipPage.do?appId=${this.settings.appId}&pageUrl=/mall-pages/wx/&path=/pages/personalCenter/tool/personalMsg` : `http://wx.kclound.com/common/skipPage.do?appId=${this.settings.appId}&pageUrl=/mall-pages/wx/&path=/pages/personalCenter/tool/personalMsg`;
        return
      }
      if(this.activeProduct.pricePoint > this.userData.pointCredit) {
        this.$toast("您的票数不够，不能兑换");
        return;
      }
      if (!this.settings.enabled) {
        this.$toast("超商卡兑换功能未开启");
        return;
      }
      if (this.activeProductId === -1) {
        this.$toast("请先选择兑换挡位");
        return;
      }

      this.confirmPhone = phone;
      this.confirmShow = true;
    },
    confirmCharge() {
      this.confirmShow = false;
      this.loadingShow = true;
      api.superBusinessCard.sbcChargeCharge(
        {
          chargePriceCent: this.activeProduct.faceValueCent,
          phone: this.confirmPhone,
          pricePoint: this.activeProduct.pricePoint,
          productId: this.activeProductId,
        },
        data => {
          this.loadingShow = false;
          console.log(data, "兑换超商卡****");
          this.succShow = true;
          if (!this.openMiniappSucc) {
            this.$nextTick(() => {
              this.openMiniapp();
            });
          }
          this.getUserPoint();
        },
        err => {
          this.$toast(err.msg);
          this.loadingShow = false;
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.open-miniapp-btn {
  position: relative;
  .launch-btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}

.container {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 4vw;
  padding-bottom: calc(34.67vw + constant(safe-area-inset-bottom));
  padding-bottom: calc(34.67vw + env(safe-area-inset-bottom));
  &.focus {
    padding-bottom: calc(0px + constant(safe-area-inset-bottom));
    padding-bottom: calc(0px + env(safe-area-inset-bottom));
  }

  .van-image {
    width: 100%;
    height: 100%;
  }

  .swiper-box {
    height: 53.33vw;
    padding: 5.33vw 0 32vw;
    background-image: linear-gradient(
      to bottom,
      #c9e3fb 0%,
      rgba(201, 222, 247, 0) 100%
    );
    .swiper-wrapper {
      .swiper-slide {
        height: 42.67vw;
        background-color: #fff;
        border-radius: 2.67vw;
        overflow: hidden;
      }
    }
  }

  .phone-box {
    margin-top: -30.67vw;
    padding: 0 5.33vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    .phone-btns {
      margin-top: 3vw;
      display: flex;
      .van-button {
        width: 28vw;
        &.firstBut {
          margin-right: 5vw;
        }
      }
    }

    .phone-ipt {
      width: 100%;
      border-radius: 2.67vw;
      overflow: hidden;
      /deep/ .van-field__right-icon {
        padding: 0 2vw 0 4vw;
      }
      .phone-ipt-icon {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 3.47vw;
        color: #ff7400;
      }
    }
  }

  .point-exchange-box {
    padding: 5.33vw;
    .exchange-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .exchange-head-title {
        font-weight: 600;
        font-size: 4.27vw;
      }
      .exchange-head-msg {
        color: #999;
        font-size: 3.47vw;
      }
    }
    .exchange-main {
      margin-top: 4vw;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2.67vw;
      .exchange-main-item {
        position: relative;
        overflow: hidden;
        height: 27.5vw;
        display: flex;
        flex-direction: column;
        border: 1px solid #f5f5f5;
        border-radius: 1.4vw;
        box-shadow: 0 0 0.27vw rgba(0, 0, 0, 0.2);
        &.other {
          font-weight: 600;
          font-size: 4.27vw;
          line-height: 1.6;
          letter-spacing: 0.2em;
          .other-cancel {
            padding: 1.5vw;
            text-align: center;
            border-color: #e17532;
            background-image: linear-gradient(
              to right,
              #eea086 0%,
              #fccfa9 100%
            );
            color: #fff;
            font-size: 2vw;
          }
        }
        .item-other-icon {
          position: absolute;
          top: 0;
          right: 0;
          border-radius: 0 0 0 1.5vw;
          padding: 0.8vw 1.8vw;
          background-color: #ff5437;
          color: #fff;
          line-height: 1;
          font-size: 2vw;
        }
        .exchange-main-item-top {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #ff5437;
          .item-top-price {
            font-weight: 600;
            font-size: 4.27vw;
          }
          .item-top-name {
            margin-top: 2.67vw;
          }
        }
        .exchange-main-item-bottom {
          padding: 1.33vw;
          text-align: center;
          color: #999;
          border-top: 1px solid #f5f5f5;
        }
        &.active {
          border-color: #e17532;
          background-color: #fff9f6;
          .exchange-main-item-bottom {
            border-color: #e17532;
            background-image: linear-gradient(
              to right,
              #eea086 0%,
              #fccfa9 100%
            );
            color: #894021;
          }
        }
      }
    }
    // .tips {
    //   margin-top: 4vw;
    //   color: #ff0000;
    //   font-size: 3vw;
    // }
  }

  .shop-box {
    position: fixed;
    left: 0;
    right: 0;
    bottom: calc(0px + constant(safe-area-inset-bottom));
    bottom: calc(0px + env(safe-area-inset-bottom));
    border-top: 1px solid #f5f5f5;
    background-color: #fff;
    &.focus {
      position: relative;
      bottom: 0;
    }

    .shop-box-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2.67vw 4.67vw 0;
      .shop-box-head-title {
        font-weight: 600;
        font-size: 4.27vw;
      }
      .shop-box-head-btn {
        height: 6.67vw;
        line-height: 6.67vw;
        padding: 0 3.33vw;
        border: 1px solid #eee;
        border-radius: 3.33vw;
        color: #999;
        font-size: 3.47vw;
      }
    }

    .shop-box-icons {
      overflow-x: auto;
      padding: 4vw 4.67vw 6.67vw;
      display: flex;
      .shop-box-icon {
        width: 13.33vw;
        height: 13.33vw;
        flex-shrink: 0;
        margin-right: 4vw;
        border: 1px solid #f6f6f6;
        &:last-child {
          margin-right: 0;
        }
      }
      .shop-box-noicon {
        height: 13.33vw;
        line-height: 13.33vw;
        color: #ff5457;
      }
    }
  }

  .dialog-box {
    width: 80vw;
    border-radius: 2.67vw;
    .dialog-head {
      position: relative;
      padding: 4.53vw;
      text-align: center;
      font-weight: 600;
      font-size: 4.27vw;
      .dialog-head-close {
        position: absolute;
        top: 2vw;
        right: 4vw;
        font-size: 7vw;
        color: #999;
        font-weight: normal;
      }
    }
    .dialog-con {
      width: max-content;
      margin: 2vw auto 6.67vw;
      .con-item + .con-item {
        margin-top: 5.33vw;
      }
      .loading-con {
        display: flex;
        flex-direction: column;
        align-items: center;
        .loading-con-text {
          margin-top: 4vw;
          text-align: center;
        }
        .van-loading {
          width: auto;
          height: auto;
        }
        .van-loading__spinner--spinner i::before {
          width: 1.6vw;
          border-radius: 0.8vw;
        }
      }
    }
    .conform-btns {
      display: flex;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/superBusinessCard/ExchangeCard.vue